var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDossier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "-64 0 464 464",
    width: "464pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m336 80v32h-32v-64c17.65625.042969 31.957031 14.34375 32 32zm0 0",
    fill: "#754c29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32 48v64h-32v-32c.0429688-17.65625 14.34375-31.957031 32-32zm0 0",
    fill: "#754c29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m304 48v64h-272v-104c0-4.417969 3.582031-8 8-8h256c4.417969 0 8 3.582031 8 8zm0 0",
    fill: "#e6e7e8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m336 432v32h-336v-32c0-17.671875 14.328125-32 32-32h272c17.671875 0 32 14.328125 32 32zm0 0",
    fill: "#a97c50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m336 112v320c0-17.671875-14.328125-32-32-32h-272c-17.671875 0-32 14.328125-32 32v-320zm0 0",
    fill: "#8b5e3c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m272 0v48l-24-16-24 16v-48zm0 0",
    fill: "#ff5023"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m320 52.320312v59.679688h-16v-64c5.621094.003906 11.140625 1.496094 16 4.320312zm0 0",
    fill: "#603913"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m32 48v64h-16v-59.679688c4.859375-2.824218 10.378906-4.316406 16-4.320312zm0 0",
    fill: "#603913"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m32 96h272v16h-272zm0 0",
    fill: "#c6c5ca"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m72 40h32v16h-32zm0 0",
    fill: "#898890"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m120 40h80v16h-80zm0 0",
    fill: "#acabb1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m72 72h192v16h-192zm0 0",
    fill: "#898890"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m168 280c-17.671875 0-32-14.328125-32-32v-72h16v72c0 8.835938 7.164062 16 16 16s16-7.164062 16-16h16c0 17.671875-14.328125 32-32 32zm0 0",
    fill: "#603913"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m200 176c0 17.671875-14.328125 32-32 32s-32-14.328125-32-32 14.328125-32 32-32 32 14.328125 32 32zm0 0",
    fill: "#754c29"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m192 176c0 13.253906-10.746094 24-24 24s-24-10.746094-24-24 10.746094-24 24-24 24 10.746094 24 24zm0 0",
    fill: "#603913"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m168 184c-1.046875-.011719-2.078125-.230469-3.039062-.640625-.96875-.40625-1.863282-.972656-2.640626-1.679687-1.503906-1.503907-2.339843-3.550782-2.320312-5.679688.03125-2.117188.859375-4.148438 2.320312-5.679688.378907-.34375.78125-.664062 1.199219-.960937.445313-.300781.929688-.542969 1.441407-.71875.453124-.230469.9375-.394531 1.4375-.480469 2.636718-.523437 5.359374.285156 7.28125 2.160156 1.476562 1.523438 2.308593 3.558594 2.320312 5.679688.019531 2.128906-.816406 4.175781-2.320312 5.679688-.777344.707031-1.671876 1.273437-2.640626 1.679687-.960937.410156-1.992187.628906-3.039062.640625zm0 0",
    fill: "#40260d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDossier);
export default __webpack_public_path__ + "static/media/dossier.46d0f55e8606d17700066da17eca3c56.svg";
export { ForwardRef as ReactComponent };